import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="employee-autofill"
// When a "Colaborador" select changes, fills the read-only "Jefe directo" / "Área"
// fields from data attributes on the chosen <option>.
export default class extends Controller {
  static targets = ["employee", "manager", "area"]

  connect() {
    this.fill()
  }

  fill() {
    const option = this.employeeTarget.selectedOptions[0]

    if (this.hasManagerTarget) this.managerTarget.value = option?.dataset.manager || ""
    if (this.hasAreaTarget) this.areaTarget.value = option?.dataset.area || ""
  }
}
